<template>
  <div class="row">
    <v-chip
      v-for="entry of firstThreeSentences"
      :key="entry.code"
      :color="entry.severity || undefined"
      :dark="entry.severity === 'red'"
    >
      {{ entry.code }}
    </v-chip>
    <div v-if="hasMoreThanThreeHAndPSentences">
      (+{{ combinedHAndPSentences.length - 3 }})
    </div>
  </div>
</template>
<script>
import { hazardSeverity } from "../../../../data/criticalHazardCodes";

export default {
  props: ["item"],
  computed: {
    combinedHAndPSentences() {
      const codes = [...(this.item?.h ?? []), ...(this.item?.p ?? [])];
      return codes.map((code) => ({
        code,
        severity: hazardSeverity(code),
      }));
    },
    firstThreeSentences() {
      //most dangerous first so red, then yellow are never hidden by the "+n"
      const rank = { red: 0, yellow: 1, "": 2 };
      return [...this.combinedHAndPSentences]
        .sort((a, b) => rank[a.severity] - rank[b.severity])
        .slice(0, 3);
    },
    hasMoreThanThreeHAndPSentences() {
      return this.combinedHAndPSentences.length > 3;
    },
  },
};
</script>

<style scoped>
.row {
  display: flex;
  column-gap: 4px;
  align-items: center;
}
</style>
